// ** Redux Imports
import {combineReducers} from 'redux'

// ** Basic Modules Reducers
import basicReducers from '@store/reducers/basicReducer'
import {officeReducer} from "@csrc/modules/office/redux/reducers"
import {requestReducer} from "@csrc/modules/request/redux/reducers"
import {trainingReducer} from "@csrc/modules/training/redux/reducers"
import {documentReducer} from "@csrc/modules/document/redux/reducers"
import {meetingReducer} from "@csrc/modules/meeting/redux/reducers"
import {dashboardReducer} from "../../modules/dashboard/redux/reducers"
import {settingsReducer} from "../../modules/settings/redux/reducers"

// ** Reducers Imports

const rootReducer = combineReducers({
	...basicReducers,
	request: requestReducer,
	office: officeReducer,
	document: documentReducer,
	meeting: meetingReducer,
	training: trainingReducer,
	dashboard: dashboardReducer,
	settings: settingsReducer
})

export default rootReducer
